import { useFetchCb } from '@gluedigital/ruse-fetch-extras'
import { AI_URL } from 'src/constants/global'
import { DatasetEntry } from './useCatalog'

export interface DatasetSearchResponse {
  query: string
  results: DatasetEntry[]
  total_candidates: number
  latency_ms: number
}

export default function useDatasetSearch() {
  const doFetch = useFetchCb()

  const search = async (query: string) => {
    const response = await doFetch(AI_URL + '/search', {
      method: 'POST',
      body: { query }
    })
    return response as DatasetSearchResponse
  }

  return { search }
}
